import type { FontCategory, FontPairing } from '@/types/shared';

const FONTS = [
  { name: 'Spectral', family: 'serif', weightParams: ':wght@300;400;500;600;700;800' },
  { name: 'Lora', family: 'serif', weightParams: ':wght@400;500;600;700' },
  { name: 'Cardo', family: 'serif', weightParams: ':wght@400;700' },
  { name: 'Source Serif 4', family: 'serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Crimson Pro', family: 'serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Literata', family: 'serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Crimson Text', family: 'serif', weightParams: ':wght@400;600;700' },
  { name: 'Quattrocento', family: 'serif', weightParams: ':wght@400;700' },
  { name: 'Merriweather', family: 'serif', weightParams: ':wght@300;400;700;900' },
  { name: 'Lustria', family: 'serif', weightParams: ':wght@400' },
  { name: 'EB Garamond', family: 'serif', weightParams: ':wght@400;500;600;700;800' },
  { name: 'Playfair Display', family: 'serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Domine', family: 'serif', weightParams: ':wght@400;500;600;700' },
  { name: 'Oswald', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700' },
  { name: 'Inter', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Bebas Neue', family: 'sans-serif', weightParams: ':wght@400' },
  { name: 'Roboto', family: 'sans-serif', weightParams: ':wght@300;400;500;700;900' },
  { name: 'Archivo Black', family: 'sans-serif', weightParams: ':wght@400' },
  { name: 'Archivo', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Anton', family: 'sans-serif', weightParams: ':wght@400' },
  {
    name: 'Source Sans 3',
    family: 'sans-serif',
    weightParams: ':wght@300;400;500;600;700;800;900',
  },
  { name: 'Poppins', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Outfit', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Nunito Sans', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Syne', family: 'sans-serif', weightParams: ':wght@400;500;600;700;800' },
  { name: 'Manrope', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800' },
  { name: 'Figtree', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Work Sans', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Urbanist', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'DM Sans', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Karla', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800' },
  { name: 'Alfa Slab One', family: 'serif', weightParams: ':wght@400' },
  { name: 'Libre Baskerville', family: 'serif', weightParams: ':wght@400;700' },
  { name: 'Lato', family: 'sans-serif', weightParams: ':wght@300;400;700;900' },
  { name: 'Newsreader', family: 'serif', weightParams: ':wght@300;400;500;600;700;800' },
  { name: 'Instrument Sans', family: 'sans-serif', weightParams: ':wght@400;500;600;700' },
  { name: 'Petrona', family: 'serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  {
    name: 'Libre Franklin',
    family: 'sans-serif',
    weightParams: ':wght@300;400;500;600;700;800;900',
  },
  { name: 'Fraunces', family: 'serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'DM Serif Display', family: 'serif', weightParams: ':wght@400' },
  { name: 'IBM Plex Sans', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700' },
  { name: 'Corben', family: 'serif', weightParams: ':wght@400;700' },
  {
    name: 'Plus Jakarta Sans',
    family: 'sans-serif',
    weightParams: ':wght@300;400;500;600;700;800',
  },
  { name: 'Bitter', family: 'serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Lexend', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Zilla Slab', family: 'serif', weightParams: ':wght@300;400;500;600;700' },
  { name: 'Questrial', family: 'sans-serif', weightParams: ':wght@400' },
  // Fonts that only reach us through imported sites, carried over from legacy
  // layouts and font pairings.
  { name: 'PT Serif', family: 'serif', weightParams: ':wght@400;700' },
  { name: 'PT Sans', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Open Sans', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800' },
  { name: 'Raleway', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Montserrat', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Barlow Condensed', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700' },
  { name: 'Asul', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Tenor Sans', family: 'sans-serif', weightParams: ':wght@400' },
  { name: 'Roboto Slab', family: 'serif', weightParams: ':wght@300;400;500;600;700;800;900' },
  { name: 'Fira Sans', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700' },
  { name: 'Fjord One', family: 'serif', weightParams: ':wght@400' },
  { name: 'Yeseva One', family: 'serif', weightParams: ':wght@400' },
  {
    name: 'Merriweather Sans',
    family: 'sans-serif',
    weightParams: ':wght@300;400;500;600;700;800',
  },
  { name: 'Josefin Sans', family: 'sans-serif', weightParams: ':wght@300;400;500;600;700' },
  { name: 'Belleza', family: 'sans-serif', weightParams: ':wght@400' },
  { name: 'Actor', family: 'sans-serif', weightParams: ':wght@400' },
  { name: 'Abel', family: 'sans-serif', weightParams: ':wght@400' },
  { name: 'Abril Fatface', family: 'serif', weightParams: ':wght@400' },
  { name: 'Alegreya', family: 'serif', weightParams: ':wght@400;700' },
  { name: 'Alegreya Sans', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Arimo', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Barlow', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Cabin', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Cormorant', family: 'serif', weightParams: ':wght@400;700' },
  { name: 'Fjalla One', family: 'sans-serif', weightParams: ':wght@400' },
  { name: 'Noto Sans', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Noto Serif', family: 'serif', weightParams: ':wght@400;700' },
  { name: 'Nunito', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Overpass', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'PT Sans Narrow', family: 'sans-serif', weightParams: ':wght@400' },
  { name: 'Roboto Condensed', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Rosario', family: 'serif', weightParams: ':wght@400' },
  { name: 'Titillium Web', family: 'sans-serif', weightParams: ':wght@400;700' },
  { name: 'Ubuntu', family: 'sans-serif', weightParams: ':wght@400;700' },
];

export type { FontCategory, FontPairing };

export const FONT_CATEGORIES: { value: FontCategory; label: string }[] = [
  { value: 'recommended', label: 'Recommended' },
  { value: 'serifs', label: 'Serif' },
  { value: 'sans-serifs', label: 'Sans' },
  { value: 'mixed', label: 'Mixed' },
];

export const FONT_WEIGHTS = [
  { value: '300', label: '300' },
  { value: '400', label: '400' },
  { value: '500', label: '500' },
  { value: '600', label: '600' },
  { value: '700', label: '700' },
  { value: '800', label: '800' },
  { value: '900', label: '900' },
];

export const CAPITALIZATION_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'uppercase', label: 'All uppercase' },
  { value: 'capitalize', label: 'Capitalize' },
  { value: 'lowercase', label: 'Lowercase' },
];

export const FONT_SIZE_OPTIONS = [
  { value: '14px', label: '14px' },
  { value: '16px', label: '16px' },
  { value: '18px', label: '18px' },
  { value: '20px', label: '20px' },
];

export const DEFAULT_HEADING_FONT = {
  font: 'Inter',
  weight: '700',
  capitalization: 'none',
} as const;

export const DEFAULT_PARAGRAPH_FONT = {
  font: 'Inter',
  weight: '400',
  size: '16px',
} as const;

// The AI service keeps its own copy of this list, so a font added or removed
// here has to be changed there too. Otherwise the AI will suggest fonts the site
// cannot use, or never suggest a new one.
export const AVAILABLE_FONTS = FONTS.map((f) => ({
  value: f.name,
  label: f.name,
  family: `'${f.name}', ${f.family}`,
})).sort((a, b) => a.label.localeCompare(b.label));

export const FONT_FAMILY_MAP: Record<string, string> = Object.fromEntries(
  AVAILABLE_FONTS.map((f) => [f.value, f.family]),
);

export const FONT_PAIRINGS: FontPairing[] = [
  {
    name: 'Spectral + Lora',
    headingFont: 'Spectral',
    paragraphFont: 'Lora',
    headingFontFamily: FONT_FAMILY_MAP.Spectral,
    paragraphFontFamily: FONT_FAMILY_MAP.Lora,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
    category: 'serifs',
  },
  {
    name: 'Cardo + Source Serif 4',
    headingFont: 'Cardo',
    paragraphFont: 'Source Serif 4',
    headingFontFamily: FONT_FAMILY_MAP.Cardo,
    paragraphFontFamily: FONT_FAMILY_MAP['Source Serif 4'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
    category: 'serifs',
  },
  {
    name: 'Crimson Pro + Literata',
    category: 'serifs',
    headingFont: 'Crimson Pro',
    paragraphFont: 'Literata',
    headingFontFamily: FONT_FAMILY_MAP['Crimson Pro'],
    paragraphFontFamily: FONT_FAMILY_MAP.Literata,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Crimson Text + Crimson Pro',
    category: 'serifs',
    headingFont: 'Crimson Text',
    paragraphFont: 'Crimson Pro',
    headingFontFamily: FONT_FAMILY_MAP['Crimson Text'],
    paragraphFontFamily: FONT_FAMILY_MAP['Crimson Pro'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Quattrocento + Merriweather',
    category: 'serifs',
    headingFont: 'Quattrocento',
    paragraphFont: 'Merriweather',
    headingFontFamily: FONT_FAMILY_MAP.Quattrocento,
    paragraphFontFamily: FONT_FAMILY_MAP.Merriweather,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Lustria + EB Garamond',
    category: 'serifs',
    headingFont: 'Lustria',
    paragraphFont: 'EB Garamond',
    headingFontFamily: FONT_FAMILY_MAP.Lustria,
    paragraphFontFamily: FONT_FAMILY_MAP['EB Garamond'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Playfair Display + Domine',
    category: 'serifs',
    headingFont: 'Playfair Display',
    paragraphFont: 'Domine',
    headingFontFamily: FONT_FAMILY_MAP['Playfair Display'],
    paragraphFontFamily: FONT_FAMILY_MAP.Domine,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Spectral + Cardo',
    category: 'serifs',
    headingFont: 'Spectral',
    paragraphFont: 'Cardo',
    headingFontFamily: FONT_FAMILY_MAP.Spectral,
    paragraphFontFamily: FONT_FAMILY_MAP.Cardo,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Oswald + Inter',
    category: 'sans-serifs',
    headingFont: 'Oswald',
    paragraphFont: 'Inter',
    headingFontFamily: FONT_FAMILY_MAP.Oswald,
    paragraphFontFamily: FONT_FAMILY_MAP.Inter,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Bebas Neue + Roboto',
    category: 'sans-serifs',
    headingFont: 'Bebas Neue',
    paragraphFont: 'Roboto',
    headingFontFamily: FONT_FAMILY_MAP['Bebas Neue'],
    paragraphFontFamily: FONT_FAMILY_MAP.Roboto,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Archivo Black + Archivo',
    category: 'sans-serifs',
    headingFont: 'Archivo Black',
    paragraphFont: 'Archivo',
    headingFontFamily: FONT_FAMILY_MAP['Archivo Black'],
    paragraphFontFamily: FONT_FAMILY_MAP.Archivo,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Anton + Source Sans 3',
    category: 'sans-serifs',
    headingFont: 'Anton',
    paragraphFont: 'Source Sans 3',
    headingFontFamily: FONT_FAMILY_MAP.Anton,
    paragraphFontFamily: FONT_FAMILY_MAP['Source Sans 3'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Poppins + Inter',
    category: 'sans-serifs',
    headingFont: 'Poppins',
    paragraphFont: 'Inter',
    headingFontFamily: FONT_FAMILY_MAP.Poppins,
    paragraphFontFamily: FONT_FAMILY_MAP.Inter,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Outfit + Nunito Sans',
    category: 'sans-serifs',
    headingFont: 'Outfit',
    paragraphFont: 'Nunito Sans',
    headingFontFamily: FONT_FAMILY_MAP.Outfit,
    paragraphFontFamily: FONT_FAMILY_MAP['Nunito Sans'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Syne + Manrope',
    category: 'sans-serifs',
    headingFont: 'Syne',
    paragraphFont: 'Manrope',
    headingFontFamily: FONT_FAMILY_MAP.Syne,
    paragraphFontFamily: FONT_FAMILY_MAP.Manrope,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Figtree + Work Sans',
    category: 'sans-serifs',
    headingFont: 'Figtree',
    paragraphFont: 'Work Sans',
    headingFontFamily: FONT_FAMILY_MAP.Figtree,
    paragraphFontFamily: FONT_FAMILY_MAP['Work Sans'],
    headingFontWeight: '700',
    paragraphFontWeight: '400',
  },
  {
    name: 'Urbanist + DM Sans',
    category: 'sans-serifs',
    headingFont: 'Urbanist',
    paragraphFont: 'DM Sans',
    headingFontFamily: FONT_FAMILY_MAP.Urbanist,
    paragraphFontFamily: FONT_FAMILY_MAP['DM Sans'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Manrope + Karla',
    category: 'sans-serifs',
    headingFont: 'Manrope',
    paragraphFont: 'Karla',
    headingFontFamily: FONT_FAMILY_MAP.Manrope,
    paragraphFontFamily: FONT_FAMILY_MAP.Karla,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Alfa Slab One + Work Sans',
    category: 'mixed',
    headingFont: 'Alfa Slab One',
    paragraphFont: 'Work Sans',
    headingFontFamily: FONT_FAMILY_MAP['Alfa Slab One'],
    paragraphFontFamily: FONT_FAMILY_MAP['Work Sans'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Libre Baskerville + Inter',
    category: 'mixed',
    headingFont: 'Libre Baskerville',
    paragraphFont: 'Inter',
    headingFontFamily: FONT_FAMILY_MAP['Libre Baskerville'],
    paragraphFontFamily: FONT_FAMILY_MAP.Inter,
    headingFontWeight: '700',
    paragraphFontWeight: '400',
  },
  {
    name: 'Crimson Text + Karla',
    category: 'mixed',
    headingFont: 'Crimson Text',
    paragraphFont: 'Karla',
    headingFontFamily: FONT_FAMILY_MAP['Crimson Text'],
    paragraphFontFamily: FONT_FAMILY_MAP.Karla,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Merriweather + Lato',
    category: 'mixed',
    headingFont: 'Merriweather',
    paragraphFont: 'Lato',
    headingFontFamily: FONT_FAMILY_MAP.Merriweather,
    paragraphFontFamily: FONT_FAMILY_MAP.Lato,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Playfair Display + DM Sans',
    category: 'mixed',
    headingFont: 'Playfair Display',
    paragraphFont: 'DM Sans',
    headingFontFamily: FONT_FAMILY_MAP['Playfair Display'],
    paragraphFontFamily: FONT_FAMILY_MAP['DM Sans'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Literata + Inter',
    category: 'mixed',
    headingFont: 'Literata',
    paragraphFont: 'Inter',
    headingFontFamily: FONT_FAMILY_MAP.Literata,
    paragraphFontFamily: FONT_FAMILY_MAP.Inter,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Merriweather + Source Sans 3',
    category: 'mixed',
    headingFont: 'Merriweather',
    paragraphFont: 'Source Sans 3',
    headingFontFamily: FONT_FAMILY_MAP.Merriweather,
    paragraphFontFamily: FONT_FAMILY_MAP['Source Sans 3'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Newsreader + Instrument Sans',
    category: 'mixed',
    headingFont: 'Newsreader',
    paragraphFont: 'Instrument Sans',
    headingFontFamily: FONT_FAMILY_MAP.Newsreader,
    paragraphFontFamily: FONT_FAMILY_MAP['Instrument Sans'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Petrona + Source Sans 3',
    category: 'mixed',
    headingFont: 'Petrona',
    paragraphFont: 'Source Sans 3',
    headingFontFamily: FONT_FAMILY_MAP.Petrona,
    paragraphFontFamily: FONT_FAMILY_MAP['Source Sans 3'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Libre Baskerville + Libre Franklin',
    category: 'mixed',
    headingFont: 'Libre Baskerville',
    paragraphFont: 'Libre Franklin',
    headingFontFamily: FONT_FAMILY_MAP['Libre Baskerville'],
    paragraphFontFamily: FONT_FAMILY_MAP['Libre Franklin'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Fraunces + Poppins',
    category: 'mixed',
    headingFont: 'Fraunces',
    paragraphFont: 'Poppins',
    headingFontFamily: FONT_FAMILY_MAP.Fraunces,
    paragraphFontFamily: FONT_FAMILY_MAP.Poppins,
    headingFontWeight: '700',
    paragraphFontWeight: '400',
  },
  {
    name: 'DM Serif Display + Libre Franklin',
    category: 'mixed',
    headingFont: 'DM Serif Display',
    paragraphFont: 'Libre Franklin',
    headingFontFamily: FONT_FAMILY_MAP['DM Serif Display'],
    paragraphFontFamily: FONT_FAMILY_MAP['Libre Franklin'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'DM Sans + Newsreader',
    category: 'mixed',
    headingFont: 'DM Sans',
    paragraphFont: 'Newsreader',
    headingFontFamily: FONT_FAMILY_MAP['DM Sans'],
    paragraphFontFamily: FONT_FAMILY_MAP.Newsreader,
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Corben + IBM Plex Sans',
    category: 'mixed',
    headingFont: 'Corben',
    paragraphFont: 'IBM Plex Sans',
    headingFontFamily: FONT_FAMILY_MAP.Corben,
    paragraphFontFamily: FONT_FAMILY_MAP['IBM Plex Sans'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Fraunces + Plus Jakarta Sans',
    category: 'mixed',
    headingFont: 'Fraunces',
    paragraphFont: 'Plus Jakarta Sans',
    headingFontFamily: FONT_FAMILY_MAP.Fraunces,
    paragraphFontFamily: FONT_FAMILY_MAP['Plus Jakarta Sans'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Bitter + Work Sans',
    category: 'mixed',
    headingFont: 'Bitter',
    paragraphFont: 'Work Sans',
    headingFontFamily: FONT_FAMILY_MAP.Bitter,
    paragraphFontFamily: FONT_FAMILY_MAP['Work Sans'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Lexend + Zilla Slab',
    category: 'mixed',
    headingFont: 'Lexend',
    paragraphFont: 'Zilla Slab',
    headingFontFamily: FONT_FAMILY_MAP.Lexend,
    paragraphFontFamily: FONT_FAMILY_MAP['Zilla Slab'],
    headingFontWeight: '400',
    paragraphFontWeight: '400',
  },
  {
    name: 'Quattrocento + Questrial',
    category: 'mixed',
    headingFont: 'Quattrocento',
    paragraphFont: 'Questrial',
    headingFontFamily: FONT_FAMILY_MAP.Quattrocento,
    paragraphFontFamily: FONT_FAMILY_MAP.Questrial,
    headingFontWeight: '700',
    paragraphFontWeight: '400',
  },
];

export const FONT_WEIGHT_PARAMS: Record<string, string> = Object.fromEntries(
  FONTS.map((f) => [f.name, f.weightParams]),
);

const WEIGHT_VALUES = FONT_WEIGHTS.map((option) => option.value);
const WEIGHT_VALUE_SET = new Set(WEIGHT_VALUES);
const WEIGHT_RANGE_REGEX = /(\d{3})\.\.(\d{3})/g;
const WEIGHT_VALUE_REGEX = /\b\d{3}\b/g;

function extractWeightRanges(params: string): Array<[number, number]> {
  return Array.from(params.matchAll(WEIGHT_RANGE_REGEX)).map((match) => [
    Number(match[1]),
    Number(match[2]),
  ]);
}

function extractWeightValues(params: string): string[] {
  return Array.from(params.matchAll(WEIGHT_VALUE_REGEX))
    .map((match) => match[0])
    .filter((value) => WEIGHT_VALUE_SET.has(value));
}

function weightsFromRanges(ranges: Array<[number, number]>): string[] {
  return WEIGHT_VALUES.filter((value) => {
    const weight = Number(value);
    return ranges.some(([min, max]) => weight >= min && weight <= max);
  });
}

function getAvailableWeightsFromParams(params: string): Set<string> {
  const ranges = extractWeightRanges(params);
  const fromRanges = weightsFromRanges(ranges);
  const fromValues = extractWeightValues(params);
  return new Set([...fromRanges, ...fromValues]);
}

export function getFontWeightOptions(fontName: string | undefined) {
  if (!fontName) return FONT_WEIGHTS;

  const params = FONT_WEIGHT_PARAMS[fontName];
  if (!params) return FONT_WEIGHTS;

  const availableWeights = getAvailableWeightsFromParams(params);
  const filtered = FONT_WEIGHTS.filter((option) => availableWeights.has(option.value));

  return filtered.length > 0 ? filtered : FONT_WEIGHTS;
}

function buildGoogleFontsUrl(fontNames: string[]): string {
  const fontParams = fontNames
    .map((font) => {
      const weightParams = FONT_WEIGHT_PARAMS[font] ?? '';
      return `family=${encodeURIComponent(font)}${weightParams}`;
    })
    .join('&');

  return `https://fonts.googleapis.com/css2?${fontParams}&display=swap`;
}

export function getAllGoogleFontsUrl(): string {
  const googleFonts = AVAILABLE_FONTS.map((f) => f.value);
  return buildGoogleFontsUrl(googleFonts);
}

export function getSpecificGoogleFontsUrl(fonts: string[]): string | null {
  // Google refuses the whole request when it does not recognise even one font
  // name, so a single system font carried in from an import would stop every
  // other font on the page loading. Only known Google fonts are asked for, and
  // anything else falls back through the usual font list in the CSS.
  const googleFonts = fonts.filter((font) => font in FONT_FAMILY_MAP);
  if (googleFonts.length === 0) {
    return null;
  }

  return buildGoogleFontsUrl(googleFonts);
}
